/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTabQueryResponse,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTabPathParams,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTab400,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTab401,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTab500,
} from "../../types/courseRegistrationEnrollmentController/GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTab.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTab } from "../../clients/courseRegistrationEnrollmentController/getApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTab.ts";

export const getApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTabQueryKey =
  (
    courseRegistrationId: GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTabPathParams["courseRegistrationId"],
  ) =>
    [
      {
        url: "/api/v1/courseregistration/enrollment/:courseRegistrationId/financial-tab",
        params: { courseRegistrationId: courseRegistrationId },
      },
    ] as const;

export type GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTabQueryKey =
  ReturnType<
    typeof getApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTabQueryKey
  >;

export function getApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTabQueryOptions(
  courseRegistrationId: GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTabPathParams["courseRegistrationId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTabQueryKey(
      courseRegistrationId,
    );
  return queryOptions<
    GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTabQueryResponse,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTab400
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTab401
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTab500
    >,
    GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTabQueryResponse,
    typeof queryKey
  >({
    enabled: !!courseRegistrationId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTab(
        courseRegistrationId,
        { ...config, signal: config.signal ?? signal },
      );
    },
  });
}

/**
 * @description Retorna informações de pagamento, forma de pagamento, plano, parcelas, descontos e taxas da matrícula, para exibição na aba Financeiro do gerenciamento. **(Requer Authorization para autenticação)**
 * @summary Retorna dados financeiros de uma matrícula (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/enrollment/:courseRegistrationId/financial-tab}
 */
export function useGetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTab<
  TData =
    GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTabQueryResponse,
  TQueryData =
    GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTabQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTabQueryKey,
>(
  courseRegistrationId: GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTabPathParams["courseRegistrationId"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTabQueryResponse,
        ResponseErrorConfig<
          | GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTab400
          | GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTab401
          | GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTab500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTabQueryKey(
      courseRegistrationId,
    );

  const query = useQuery(
    {
      ...getApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTabQueryOptions(
        courseRegistrationId,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTab400
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTab401
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTab500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
